import React from "react";
import { Table } from "reactstrap";
import { TableRow } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardQuestionnaire/Question/CompositeField/TableRow";

export const CompositeField = ({ data, identifier }) => {
  const tableHeaderData = data[0];
  const tableBodyData = data.slice(1);

  return (
    <Table>
      <thead>
        <tr>
          {tableHeaderData.values.map((item, i) => (
            <th key={i}>{item.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableBodyData.map((row) => (
          <TableRow
            key={row.fieldKey}
            rowData={row}
            rowsCount={tableHeaderData.values.length}
            parentId={`${identifier}/#${row.fieldKey}`}
          />
        ))}
      </tbody>
    </Table>
  );
};
